/* Sho — shared JS primitives for all sho-* sections.
   Ported 1:1 from sho-strategy-mockups/sho-value-prop-page-v1.html.
   Defines window.ShoShared = { sign, initReveal } — safe to include on
   every sho-* section that needs it; redefining is harmless (pure functions,
   no state), so duplicate <script> tags across sections cause no drift. */
window.ShoShared = window.ShoShared || (function(){

  /* ---------- scroll reveal (call once; safe to call again, re-queries .sho-reveal) ---------- */
  function initReveal(){
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {threshold:.14});
    [].forEach.call(document.querySelectorAll('.sho-reveal:not([data-sho-reveal-bound])'), function(el, i){
      el.setAttribute('data-sho-reveal-bound', '1');
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
      io.observe(el);
    });
  }

  /* ---------- designed mini-sign renderer (turns "LUNCH / Combo $9.99" into an actual sign layout) ---------- */
  function sign(cls, html){
    var m = /<b>([\s\S]*?)<\/b>(?:<small>([\s\S]*?)<\/small>)?/.exec(html), t, s;
    if (m) { t = m[1]; s = m[2] || ''; } else { t = html; s = ''; }
    t = t.replace(/^&#9888;\s*/, '').trim();
    var type = (cls.match(/sho-c-(\w+)/) || cls.match(/c-(\w+)/) || [])[1] || 'info';
    var glow = '<span class="sho-glow"></span>';
    var pr = ((s.match(/\$[\d.,]+/) || html.match(/\$[\d.,]+/) || [''])[0]).replace(/^\$/, '');
    var nm = s.replace(/\$[\d.,]+/, '').replace(/\s+/g, ' ').trim();
    /* deterministic per-tile palette (FNV-1a 32-bit hash over type+title+small,
       then a 3-round xorshift-multiply avalanche) — same content -> same skin
       forever; different content -> different skin. No run-time randomness. */
    var PAL = {
      menu: ['sho-sg-mA','sho-sg-mB','sho-sg-mC'],
      promo: ['sho-sg-pA','sho-sg-pB','sho-sg-pC','sho-sg-pD'],
      sched: ['sho-sg-sA','sho-sg-sB','sho-sg-sC'],
      wifi: ['sho-sg-wA','sho-sg-wB'],
      info: ['sho-sg-iA','sho-sg-iB','sho-sg-iC'],
      alert: ['sho-sg-aA','sho-sg-aB']
    };
    var list = PAL[type] || PAL.info, hstr = type + '␟' + t + '␟' + s, h = 0x811c9dc5 >>> 0;
    for (var _i = 0; _i < hstr.length; _i++) { h ^= hstr.charCodeAt(_i); h = Math.imul(h, 0x01000193) >>> 0; }
    h ^= h >>> 15; h = Math.imul(h, 0x2c1b3c6d) >>> 0; h ^= h >>> 12; h = Math.imul(h, 0x297a2d39) >>> 0; h ^= h >>> 15; h = h >>> 0;
    var pv = list[h % list.length];
    var deco = '<span class="sho-sg-tex"></span>';
    var glass = '<span class="sho-sg-glass"></span>';
    if (type === 'menu') {
      var prHtml = pr ? '<span class="sho-pr"><em>$</em>' + pr + '</span>' : '';
      var feat = (nm || pr) ? '<div class="sho-mitem"><span class="sho-nm">' + (nm || 'Today') + '</span>' + prHtml + '</div>' : '';
      return '<div class="sho-sg-glass-host sho-sg sho-menu ' + pv + '">' + deco + glass + glow +
        '<span class="sho-kick"><span class="sho-kd"></span>' + t + '</span>' + feat +
        '<div class="sho-rows"><span class="sho-mrow"><span class="sho-nm" style="width:46%"></span><span class="sho-dots"></span><span class="sho-pr"></span></span>' +
        '<span class="sho-mrow"><span class="sho-nm" style="width:60%"></span><span class="sho-dots"></span><span class="sho-pr"></span></span></div>' +
        '<span class="sho-foot"></span></div>';
    }
    if (type === 'promo') {
      var spark = '<svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor" stroke="none"><path d="M12 2l1.9 6.1L20 10l-6.1 1.9L12 18l-1.9-6.1L4 10l6.1-1.9z"/></svg>';
      var chip = s ? '<span class="sho-chip">' + s + '</span>' : '';
      return '<div class="sho-sg-glass-host sho-sg sho-promo ' + pv + '">' + deco + glass + glow + '<span class="sho-burst">' + spark + '</span><div class="sho-hd">' + t + '</div>' + chip + '</div>';
    }
    if (type === 'sched') {
      return '<div class="sho-sg-glass-host sho-sg sho-sched ' + pv + '">' + deco + glass + glow +
        '<span class="sho-kick"><span class="sho-kd"></span>Schedule</span>' +
        '<div class="sho-hd">' + t + '</div>' +
        '<div class="sho-trow now"><span class="sho-tm">Now</span><span class="sho-ev"></span><span class="sho-nowdot"></span></div>' +
        '<div class="sho-trow"><span class="sho-tm">11:30</span><span class="sho-ev" style="flex:.68"></span></div>' +
        '<div class="sho-trow"><span class="sho-tm">1:00</span><span class="sho-ev" style="flex:.84"></span></div></div>';
    }
    if (type === 'wifi') {
      var warc = '<svg class="sho-warc" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 8.5a15 15 0 0120 0"/><path d="M5 12a10 10 0 0114 0"/><path d="M8.5 15.5a5 5 0 017 0"/><circle cx="12" cy="19" r="1.2" fill="currentColor" stroke="none"/></svg>';
      return '<div class="sho-sg-glass-host sho-sg sho-wifi ' + pv + '">' + deco + glass + glow + warc + '<div class="sho-hd">' + t + '</div>' +
        '<div class="sho-wcard"><span class="sho-wl">PASS</span><span class="sho-wd"><i></i><i></i><i></i><i></i><i></i></span></div></div>';
    }
    if (type === 'alert') {
      var warn = '<svg class="sho-warn" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.9 1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z"/><line x1="12" y1="9" x2="12" y2="13.5"/><line x1="12" y1="17" x2="12" y2="17.1"/></svg>';
      return '<div class="sho-sg-glass-host sho-sg sho-alert ' + pv + '">' + deco + glass + glow + warn + '<div class="sho-hd">' + t + '</div>' + (s ? '<div class="sho-sub">' + s + '</div>' : '') + '</div>';
    }
    return '<div class="sho-sg-glass-host sho-sg sho-info ' + pv + '">' + deco + glass + glow + '<span class="sho-brandbar"></span><div class="sho-hd">' + t + '</div><span class="sho-rule"></span>' + (s ? '<div class="sho-sub">' + s + '</div>' : '') + '</div>';
  }

  return { sign: sign, initReveal: initReveal };
})();

document.addEventListener('DOMContentLoaded', function(){ window.ShoShared.initReveal(); });
if (document.readyState === 'interactive' || document.readyState === 'complete') { window.ShoShared.initReveal(); }
